
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { DataTablesModule } from 'angular-datatables';
import { MaterialDesignModule } from './modules/material-design.module';
import { SignaturePadModule } from 'angular2-signaturepad';
import { SignaturePad } from 'angular2-signaturepad';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { KendoModule } from './modules/kendo.module';

import { AutofocusDirective } from './directives/autofocus';

@NgModule({
  declarations: [
    AutofocusDirective,
    
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialDesignModule,
    DataTablesModule,
    AppRoutingModule,
    KendoModule,
    SignaturePadModule 
  ],
  exports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialDesignModule,
    DataTablesModule,
    AppRoutingModule,
    KendoModule
  ]
})
export class ComponentModule {

}
